'use client';

import { useRef } from 'react';
import clsx from 'classnames';

import { BreadcrumbItemProps } from './types';
import styles from './Breadcrumbs.module.scss';

export function BreadcrumbItem({
	as = 'a',
	target = '_self',
	href,
	prefetch = false,
	className,
	...props
}: BreadcrumbItemProps) {
	const ref = useRef<HTMLSpanElement>(null);
	const Component = props.isDisabled ? 'span' : as;

	const classNames = clsx(
		styles.breadcrumbItem,
		{
			[styles[`breadcrumbItem--disabled`]]: !!props.isDisabled,
			[styles[`breadcrumbItem--current`]]: props.isCurrent,
			[styles[`breadcrumbItem--first`]]: props.isFirst,
			[styles[`breadcrumbItem--bold`]]: props.isBold,
		},
		className
	);

	return (
		<li className={styles.breadcrumbItemWrapper}>
			<Component
				// {...itemProps}
				{...(props.isDisabled ? {} : { href, target, prefetch })}
				ref={ref}
				className={classNames}
			>
				{props.children}
			</Component>
			{!props.isCurrent && (
				<span aria-hidden="true" style={{ padding: '0 5px' }}>
					&#187;
				</span>
			)}
		</li>
	);
}
